import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=8a431cde&scoped=true"
import script from "./Recipient.vue?vue&type=script&lang=js"
export * from "./Recipient.vue?vue&type=script&lang=js"
import style0 from "./Recipient.vue?vue&type=style&index=0&id=8a431cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a431cde",
  null
  
)

/* custom blocks */
import block0 from "./Recipient.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports